import {vpost} from "@/util/post";

export const eventorder = {
    list: async (pageSize, pageCurrent, key, status, team) => {
        let dto = {
            pageSize, pageCurrent, key, status, "dealerId": Number.parseInt(team),
        }
        return (await vpost("/eventorder/list", dto));
    },

    detail: (id) => {
        return vpost("/eventorder/detail?id=" + id);
    },
    getOrderDetail(id) {
        return vpost("/eventorder/getOrderDetail?id=" + id);
    },
    checkStep(stepId) {
        return vpost("/eventorder/check?stepId=" + stepId);
    },
    resetStep(stepId) {
        return vpost("/eventorder/resetStep?stepId=" + stepId);
    },
    finishOrder(id) {
        return vpost("/eventorder/finishOrder?id=" + id);
    },
    regenerateQRCodes(id) {
        return vpost("/eventorder/regenerateQRCodes?id=" + id);
    },

    listEventTag(id) {
        return vpost("/eventorder/listEventTagVO?id=" + id);
    },

    updateEventTag(id, name) {
        return vpost("/eventorder/updateEventTag?id=" + id + "&name=" + name);
    },
    deleteEventTag(id) {
        return vpost("/eventorder/deleteEventTag?id=" + id);
    },
    createEventTag(eventOrderId, name) {
        let dto = {
            eventOrderId: eventOrderId,
            tagName: name
        }
        return vpost("/eventorder/createEventTag", dto);
    },
    createFromTemplate(dto) {
        return vpost("/eventorder/createFromTemplate", dto);
    },
    /**
     *
     * @param eventOrderId
     * @param tagId
     * @param pageCurrent
     * @param pageSize
     * @returns {Promise} imgPage
     */
    showImgs(eventOrderId, tagId, pageCurrent, pageSize) {
        let dto = {
            eventOrderId,
            tagId,
            pageCurrent,
            pageSize
        }
        return vpost("/eventorder/imgs", dto);
    },

}
